import { Editor, Formatters, FormTypesData, IFileData, KeyValueData, Quill, TableConfiguration } from '../domains/common.domain';

export const FormatterData: Formatters = {
  date: {
    dateFormat: 'dd.mm.yy',
    placeholder: 'TT.MM.JJJJ',
  },
};
export const EditorStyle: Editor = {
  height: '150px',
};

export const QuillConfig: Quill = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['clean'], // remove formatting button
      ['link'],
    ],
  },
};

export const FileData: IFileData = {
  BUSINESSREGISTRATION: 'business_registration',
  PROOFOFQUALIFICATION: 'proof_of_qualification',
  PROOFOFEXPERTISE: 'proof_of_expertise',
  PROOFOFCONTRACT: 'proof_of_contract',
  ENTRYINTRADEREGISTER: 'entry_in_trade_register',
  ENTRYATCHAMBEROFHANDICRAFTS: 'entry_at_chamber_of_handicrafts',
  PROOFOFINDEMNITYINSURANCE: 'proof_of_indemnity_insurance',
  IDCARDMAINFRAUD: 'id_card_main_fraud',
  WELDINGCERTIFICATECONFIRMATION: 'welding_certificate_confirmation',
  PROOF80HOURSTRWI: 'proof_80_hours_trwi',
  ONEDAYTRAININGTRGI2018: 'one_day_training_trgi_2018',
  ONEDAYTRAININGTRWI: 'one_day_training_trwi',
  GASCOURSECENTRALHEATINGVENTILATIONDURATION: 'gas_course_central_heating_and_ventilation_duration',
  PROOF100HOURSTRGI: 'proof_100_hours_trgi',
  WELDINGCERTIFICATECONFIRMATIONNOTREQUIRED: 'welding_certificate_confirmation_not_required',
  SAFETYTECHNOLOGYAUTHORIZATION: 'safety_technology_authorization',
  PROOFOFVDESUBSCRIPTION: 'proof_of_vde_subscription',
};

export const UserStatus: KeyValueData = {
  REVOKED: 'REVOKED',
  GRANTED: 'GRANTED',
  ISSUED: 'ISSUED',
  PARTIALLY_ISSUED: 'PARTIALLY_ISSUED',
  SUBMITTED: 'SUBMITTED',
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  BLOCKED: 'BLOCKED',
  AUTOMATICALLY_REVOKED: 'AUTOMATICALLY_REVOKED',
};

export const UserRoles = {
  standardTechnician: 'standard_technician',
  guestTechnician: 'guest_technician',
  customer: 'customer',
  chimneySweeper: 'chimney_sweeper',
  employee: 'employee',
  observer: 'observer',
  administrator: 'administrator',
};

export const GridConnectionApplicationType: KeyValueData = {
  Change: 'change',
  ConversionGas: 'conversion_gas',
  ConversionHeat: 'conversion_heat',
  FeedInSystem: 'feedin',
  New: 'new',
  Temporary: 'temp',
  SiteElectricityMeterdata: 'construction_site_installation',
  GridCompatibility: 'gridcomp',
  RegEP: 'regep',
};

export const InstallationFlowType = {
  NewInstallation: 'newInstallation',
  UpdateInstallation: 'updateInstallation',
  MainsConnection: 'mainsConnection',
  FeedInSystem: 'feedInSystem',
  TemporaryConnection: 'temporaryConnection',
  SiteElectricityMeterdata: 'siteElectricityMeterdata',
  ChangeHouseConnection: 'changeHouseConnection',
  ConversionToGas: 'conversionToGas',
  GridCompatibility: 'gridCompatibility',
  RegEP: 'regep',
  ConsumptionDevices: 'consumptionDevices',
};

export const InstallationChangeType: KeyValueData = {
  PowerIncrease: 'power_increase',
  DeviceChange: 'device_change',
  SystemSeparation: 'system_seperation',
  SystemMerge: 'system_merge',
  UsageAdjustment: 'usage_adjustment',
};

export const FacilityFormTypes = {
  Power: {
    childElement: 'specialAppliance',
    index: 0,
    key: 'power',
  },
  Gas: {
    childElement: 'gasDevice',
    index: 1,
    key: 'gas',
  },
  Water: {
    childElement: 'waterDevice',
    index: 2,
    key: 'water',
  },
  Heating: {
    childElement: '',
    index: 3,
    key: 'heating',
  },
};

export const FacilityFormType: FormTypesData[] = Object.values(FacilityFormTypes);

export const TechnicianFormType: FormTypesData[] = [
  {
    childElement: 'specialDevice',
    index: 0,
    key: 'single-family',
    lookUpKey: 'single',
  },
  {
    childElement: 'specialDevice',
    index: 1,
    key: 'multi-family',
    lookUpKey: 'multi',
  },
  {
    childElement: 'specialDevice',
    index: 2,
    key: 'apartment-house',
    lookUpKey: 'multi_over_six',
  },
  {
    childElement: 'specialDevice',
    index: 3,
    key: 'temporary-connection',
    lookUpKey: '',
  },
  {
    childElement: 'specialDevice',
    index: 4,
    key: 'shutdown',
    lookUpKey: 'shutdown',
  },
  {
    childElement: 'specialDevice',
    index: 5,
    key: 'reinforce',
    lookUpKey: 'reinforce',
  },
  {
    childElement: 'specialDevice',
    index: 6,
    key: 'reallocation',
    lookUpKey: 'reallocation',
  },
  {
    childElement: 'specialDevice',
    index: 7,
    key: 'conversion_gas',
    lookUpKey: 'conversion_gas',
  },
  {
    childElement: 'specialDevice',
    index: 8,
    key: 'conversion_heat',
    lookUpKey: 'conversion_heat',
  },
  {
    childElement: 'specialDevice',
    index: 9,
    key: 'commercial',
    lookUpKey: 'commercial',
  },
];

export const AllLabels: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  app: {
    login: 'Login',
    lsw: 'LSW',
    servicePortal: 'HAUSANSCHLUSSPORTAL',
  },
  units: {
    area: 'm\xB2',
    deliveryPressure: 'Bar',
    length: 'm',
    peakFlow: 'l/s',
    power: 'kW',
    pressure: 'mBar',
    price: '€',
    temperature: '°C',
    volume: 'kWh',
    volumeFlowRate: 'm\xB3/h',
    volumeHeat: 'MW',
    volumeWater: 'm\xB3',
    wattPower: 'kWp',
    wattPowerUnit: 'W(p)',
    kilowattPowerUnit: 'kW(p)',
    millimeter: 'mm',
    centiMeterSquare: 'cm\xB2',
  },
};

export const UrlSegments: {
  [key: string]: string;
} = {
  activeStandardTechnicians: 'role=standard_technician&status=active,blocked&concessions_expired=0',
  activeGuestTechnicians: 'role=guest_technician&status=active,blocked&concessions_expired=0',
  submittedTechnicianApplications: 'status=submitted,expired,partially_issued,renew_requested',
  rejectedTechnicians: 'status=revoked',
  registeredChimneySweepers: 'role=chimney_sweeper',
};

export const AllDropdownKeys = {
  AdminRole: 'sk_admin_role',
};

export const ConcessionStatus = {
  expired: 'EXPIRED',
  issued: 'ISSUED',
  partially_issued: 'PARTIALLY_ISSUED',
  granted: 'GRANTED',
  created: 'CREATED',
  renew_requested: 'RENEW_REQUESTED',
  revoked: 'REVOKED',
  submitted: 'SUBMITTED',
};

export const FeedInOperationMode: {
  [key: string]: string;
} = {
  islandMode: 'island_mode',
  feedInExcess: 'excess',
  feedIn70: '70',
  feedIn100: '100',
  feedIn60: '60',
  feedInFull: 'full',
  other: 'other',
};

export const MessageType: {
  [key: string]: string;
} = {
  PASSWORD_CHANGED: 'password changed successfully',
  CHANGES_SAVED: 'changes saved successfully',
  ERROR: 'error',
  REQUEST_SUBMISSION: 'request submitted',
  DYNAMIC: 'message',
};

export const TableConfig: TableConfiguration = {
  rowsPerPageOptions: [15, 20, 25, 30],
  rowsPerPage: 15,
};

export const AdditionalMeasuringConcepts: string[] = [
  'MK A1',
  'MK A2',
  'MK A3',
  'MK B2',
  'MK B2a',
  'MK B3',
  'MK B4',
  'MK C1',
  'MK C2',
  'MK C3',
  'MK D1',
  'MK D2',
  'MK E2',
  'MK F1',
  'MK Z1',
  'MK Z2',
  'MK Z3',
];

export const BaseMandatoryDocumentsPerCommodity = {
  documentsCompany: [
    FileData.BUSINESSREGISTRATION,
    FileData.ENTRYINTRADEREGISTER,
    FileData.ENTRYATCHAMBEROFHANDICRAFTS,
    FileData.PROOFOFINDEMNITYINSURANCE,
  ],
  documentsSpecialist: [FileData.PROOFOFQUALIFICATION, FileData.PROOFOFEXPERTISE, FileData.PROOFOFCONTRACT],
};

export const ApplicationSectionKeys = {
  personalData: {
    connectionAddress: 'personalData-connectionAddress',
  },
  technicalData: {
    districtHeatDevice: 'technicalData-districtHeatDevice',
    gasDevice: 'technicalData-gasDevice',
    waterDevice: 'technicalData-waterDevice',
  },
  documents: {},
};
